import EmailChannelConst from "./email-channel-const";
import EmailChannelFields from "./fields";
import EmailChannelForms from "./forms";
import EmailChannelGuide from "./guide";
import EmailChannelEmptyState from "./empty-state";
import EmailChannelHelpers from "./helpers";
import { emailChannelUseMutation } from "./hooks";

const EmailChannel = {
  Const: EmailChannelConst,
  Fields: EmailChannelFields,
  Forms: EmailChannelForms,
  Guide: EmailChannelGuide,
  EmptyState: EmailChannelEmptyState,
  Helpers: EmailChannelHelpers,
  Hooks: emailChannelUseMutation,
};

export default EmailChannel;
